import React, { useEffect, Suspense } from 'react';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import Layout from './hoc/Layout/Layout';
import Logout from './containers/Auth/Logout/Logout';

import * as actions from './store/actions/index';
import 'bootstrap/dist/css/bootstrap.min.css';

import HomePage from './containers/HomePage/HomePage';

const Auth = React.lazy(() => {
  return import('./containers/Auth/Auth');
});

const ChapterList = React.lazy(() => {
  return import('./containers/ChapterList/ChapterList');
});

const HadithList = React.lazy(() => {
  return import('./containers/HadithList/HadithList');
});


const app = props => {
  const { onTryAutoSignup } = props;

  useEffect(() => {
    onTryAutoSignup();
  }, [onTryAutoSignup]);

  let routes = (
    <Switch>
      <Route path="/ChapterList" render={props => <ChapterList {...props} />} />
      <Route path="/HadithList" render={props => <HadithList {...props} />} />
      <Route path="/" render={props => <Auth {...props} />} />
    </Switch>
  );

  
  if (props.isAuthenticated) {
    routes = (
      <Switch>
        <Route path="/HadithList" render={props => <HadithList {...props} />} />
        <Route path="/ChapterList" render={props => <ChapterList {...props} />} />
        <Route path="/logout" component={Logout} />
        <Route path="/" render={props => <HomePage {...props} />}/>
        <Redirect to="/" />
      </Switch>
    );
  }

  return (
    <div>
      <Layout>
        <Suspense fallback={<p>Loading...</p>}>{routes}</Suspense>
      </Layout>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.token !== null,
    admin: state.auth.admin,
    org: state.auth.org,
    userEmail: state.auth.userEmail,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState())
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(app)
);



// WEBPACK FOOTER //
// ./src/App.js